import{Children,cloneElement,isValidElement,type ReactElement,type ReactNode}from"react";
import{useAppI18n}from"../../lib/appI18n";
import{translateIdentityText}from"./identityAccessMessages.mjs";
const STRING_PROPS=["title","description","label","placeholder","detail","aria-label"] as const;
function walk(node:ReactNode,locale:"tr"|"de"|"en"):ReactNode{
 if(typeof node==="string")return translateIdentityText(node,locale);
 if(Array.isArray(node))return node.map(x=>walk(x,locale));
 if(!isValidElement(node))return node;
 const element=node as ReactElement<Record<string,unknown>>,props=element.props||{},patch:Record<string,unknown>={};
 for(const key of STRING_PROPS){const value=props[key];if(typeof value==="string")patch[key]=translateIdentityText(value,locale);}
 if("children"in props)patch.children=Children.map(props.children as ReactNode,child=>walk(child,locale));
 return cloneElement(element,patch);
}
export function IdentityAccessTranslate({children}:{children:ReactNode}){const{locale}=useAppI18n();return <>{walk(children,locale)}</>;}
